import React, { useContext, useState, useEffect, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "./StackedColumnsChart.scss";
import { AppContext } from "../../../context/Context";

const StackedColumnsChart = ({ datas }) => {
  const { fromDate, clearState } = useContext(AppContext);
  const [active, setActive] = useState();  

  useEffect(() => {
    // if (fromDate === "All") {
    //   if (clearState === "") {
    //     setActive(true);
    //     // console.log("testtrue");
    //   } else if (clearState === null) {
    //     // console.log("run else if");

    //     setTimeout(() => {
    //       setActive(true);
    //     }, 1050);
    //   } else {
    //     setActive(false);
    //     // console.log("testtrue");
    //   }
    // } else {
    //   if (clearState !== "") {
    //     setTimeout(() => {
    //       setActive(true);
    //     }, 1050);
    //   }
    //   // setActive(true);
    // }
    setActive(true)
  }, [setActive, fromDate, clearState]);

  const visualizeData = datas.map((item, index) => {
    return {
      ...item,
      totalRevenue: item.revenue,
    };
  });  

  // CustomTooltip.jsx
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div className="tooltip-containers">
          <p className="tooltip-title">{item.month}</p>
          <p className="tooltip-value">
            DD Compensation: {""}
            {item.totalRevenue.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>

          {item.greenIncrease && (
            <div className="tooltip-increase">
              <span></span>
              <p>
                Reveue Share: {""}
                {item.greenIncrease.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </p>
            </div>
          )}

          {item.yellowdecrease ? (
            <div className="tooltip-decrease">
              <span></span>

              <p>
                OnBoarding Fee: {""} -
                {item.yellowdecrease.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    }
    return null;
  };

  // AnimatedCustomBar component with sequential animation
  const AnimatedCustomBar = (props) => {
    const { x, y, width, height, index } = props;
    const item = visualizeData[index];

    const [mainBarProgress, setMainBarProgress] = useState(0);
    const [greenBarProgress, setGreenBarProgress] = useState(0);
    const [yellowBarProgress, setYellowBarProgress] = useState(0);
    const animationRef = useRef(null);

    // Calculate the heights for the segments
    const maxValue = 150000; // Using your fixed value as in original code
    const scaleHeight = 300; // As used in your original calculations

    const fullYellowHeight = item.yellowdecrease
      ? (item.yellowdecrease / maxValue) * scaleHeight
      : 0;

    const fullGreenHeight = item.greenIncrease
      ? (item.greenIncrease / maxValue) * scaleHeight
      : 0;

    // Apply animation progress
    const currentHeight = height * mainBarProgress;
    const greenHeight = fullGreenHeight * greenBarProgress;
    const yellowHeight = fullYellowHeight * yellowBarProgress;

    // Animation effect
    useEffect(() => {
      if (active) {
        // Clear any existing animation
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }

        let startTime = null;
        const mainBarDuration = 400; // Main bar animation duration in ms
        const greenBarDuration = 300; // Green bar animation duration in ms
        const yellowBarDuration = 300; // Yellow bar animation duration in ms
        const totalDuration =
          mainBarDuration + greenBarDuration + yellowBarDuration;

        // Animation function
        const animate = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;

          // First animate the main bar
          if (elapsed < mainBarDuration) {
            const progress = Math.min(elapsed / mainBarDuration, 1);
            setMainBarProgress(progress);
          }
          // Then animate the green bar
          else if (elapsed < mainBarDuration + greenBarDuration) {
            setMainBarProgress(1); // Ensure main bar is complete
            const greenElapsed = elapsed - mainBarDuration;
            const greenProgress = Math.min(greenElapsed / greenBarDuration, 1);
            setGreenBarProgress(greenProgress);
          }
          // Finally animate the yellow bar
          else if (elapsed < totalDuration) {
            setMainBarProgress(1);
            setGreenBarProgress(1);
            const yellowElapsed = elapsed - mainBarDuration - greenBarDuration;
            const yellowProgress = Math.min(
              yellowElapsed / yellowBarDuration,
              1
            );
            setYellowBarProgress(yellowProgress);
          }
          // Animation complete
          else {
            setMainBarProgress(1);
            setGreenBarProgress(1);
            setYellowBarProgress(1);
          }

          if (elapsed < totalDuration) {
            animationRef.current = requestAnimationFrame(animate);
          }
        };

        // Start animation
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setMainBarProgress(0);
        setGreenBarProgress(0);
        setYellowBarProgress(0);
      }

      // Cleanup function
      return () => {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
      };
    }, [active]);

    return (
      <g>
        <defs>
          <linearGradient id="colorBlue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#E7DFF7" stopOpacity={1} />
            <stop offset="100%" stopColor="#6B89F7" stopOpacity={1} />
          </linearGradient>
          <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8CD867" stopOpacity={1} />
            <stop offset="100%" stopColor="#8CD867" stopOpacity={1} />
          </linearGradient>
        </defs>

        {/* Yellow decrease should cut from the bottom - animated */}
        {fullYellowHeight > 0 && (
          <rect
            x={x}
            y={y + height}
            width={width}
            height={yellowHeight}
            rx={4}
            ry={4}
            fill="#FFF9A6"
            style={{ cursor: "pointer" }}
          />
        )}

        {/* Main revenue bar - animated */}
        <rect
          x={x}
          y={y + height - currentHeight}
          width={width}
          height={currentHeight}
          fill="url(#colorBlue)"
          rx={4}
          ry={4}
          style={{ cursor: "pointer" }}
        />

        {/* Green increase should go on top - animated */}
        {fullGreenHeight > 0 && (
          <rect
            x={x}
            y={y - greenHeight}
            width={width}
            height={greenHeight}
            fill="url(#colorGreen)"
            rx={4}
            ry={4}
            style={{ cursor: "pointer" }}
          />
        )}
      </g>
    );
  };

  return (
    <div style={{ width: "100%", height: 500 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={visualizeData}
          margin={{ top: 30, right: 30, left: 20, bottom: 20 }}
          barSize={50}
        >
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
            horizontal={false}
          />
          <XAxis dataKey="month" axisLine={false} tick={{ fontSize: 15 }} />
          <YAxis
            tickFormatter={(value) => `$${(value / 1000).toFixed(2)}K`}
            domain={[0, 150000]}
            axisLine={false}
            tick={{ fontSize: 15 }}
            padding={{ bottom: 70 }}
          />

          <Tooltip cursor={false} content={<CustomTooltip />} />
          <Bar
            dataKey="totalRevenue"
            shape={<AnimatedCustomBar />}
            cursor={"pointer"}
            isAnimationActive={false} // We handle animation ourselves
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackedColumnsChart;
